export function fmt(d) {
  if (!d) return "";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) +
    " " + dt.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
}

export function duration(start, end) {
  if (!start || !end) return "";
  const m = Math.round((new Date(end) - new Date(start)) / 60000);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`;
}
